'use strict'
import api from '@/api/api'
import notify from '@/utils/notify'

export default {
  async list(params = {}) {
    const query = new URLSearchParams(params).toString()
    const url = query ? `feedback-requests?${query}` : 'feedback-requests'
    const data = { method: 'get', url }
    const response = await api.api(data)
    if (response.status === 200) return response.data
    return []
  },

  //user feedback requests
  async getUserFeedbackRequests(id) {
    const data = { method: 'get', url: `feedback-requests/user/${id}` }
    const response = await api.api(data)
    if (response.status === 200) return response.data
    return []
  },

  async create(json) {
    const data = { method: 'post', url: 'feedback-requests', body: json }
    const response = await api.api(data)
    if (response.status === 201 || response.status === 200) {
      notify.alert.success('Feedback request created successfully')
      return response.data
    }
  },

  async get(id) {
    const data = { method: 'get', url: `feedback-requests/${id}` }
    const response = await api.api(data)
    if (response.status === 200) return response.data
  },

  async update(id, json) {
    const data = { method: 'patch', url: `feedback-requests/${id}`, body: json }
    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Feedback request updated successfully')
      return response.data
    }
  },

  async destroy(id) {
    const data = { method: 'delete', url: `feedback-requests/${id}` }
    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Feedback request deleted successfully')
      return true
    }
  }
}
